import { render } from "./chat.vue?vue&type=template&id=5cf02115&scoped=true&ts=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"

import "./chat.vue?vue&type=style&index=0&id=5cf02115&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf02115"]])

export default __exports__